export enum EBackgroundTaskFlag {

  TaskStarted = "backgroundTaskStarted",
  TaskRunning = "backgroundTaskRunning",
  TaskFinished = "backgroundTaskFinished",
  TaskError = "backgroundTaskError",
  BackgroundTaskServiceInitialized = "btsInitialized"
}